function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35 35"
}, props), React.createElement("path", {
  d: "M17.5 0c-1.14 0-2.059.92-2.059 2.059V15.44H2.06C.919 15.441 0 16.361 0 17.5c0 1.14.92 2.059 2.059 2.059H15.44V32.94c0 1.14.92 2.059 2.059 2.059 1.14 0 2.059-.92 2.059-2.059V19.56H32.94c1.14 0 2.059-.92 2.059-2.059 0-1.14-.92-2.059-2.059-2.059H19.56V2.06C19.559.919 18.639 0 17.5 0z",
  fill: "#0A537A"
})));